export class ImageSetting {
  imageOperation: string; // 影像设置
}
